import { TournamentEntity } from 'app/interfaces/entity';
import { apiRequestCall } from 'app/services/api';
import { ApiResource } from 'app/services/api/enums';

export const updateTournament = (id: string, data: Pick<TournamentEntity, 'isHidden'>) => {
  return apiRequestCall({
    params: {
      method: 'PATCH',
      resource: ApiResource.Admin,
      urlPrefix: `${ApiResource.Tournaments}/${id}`,
      data: data,
    },
  });
};
